import React, { FC } from "react";

import BaseDataTableWithSort from "../../../../../components/modules/BaseDataTableWithSort";
import Loader from "../../../../../components/elements/Loader";
import classes from "../../CampaignsDashboard.module.scss";
import { AdLibCreativeReportType, ReportTimeFrames } from "../../../../../types/campaignTypes";
import { CreativeAsset } from "../../../../../types/adGroupTypes";
import { transformRowValue } from "../../../../../helpers/campainRowFormatHelpers";

type CreativeAssetsProps = {
  creativeAssets: CreativeAsset[];
  isFetchingCreatives: boolean;
  creativeDailyReports: AdLibCreativeReportType[];
  selectedTimeFrame: ReportTimeFrames;
};

const CreativeAssetsManagement: FC<CreativeAssetsProps> = ({
  creativeAssets,
  isFetchingCreatives,
  creativeDailyReports,
  selectedTimeFrame,
}) => {
  const columns = [
    { key: "asset", label: "Asset", minWidth: 170 },
    { key: "name", label: "Name", minWidth: 170 },
    { key: "height", label: "Height", minWidth: 100 },
    { key: "width", label: "Width", minWidth: 100 },
    { key: "duration", label: "Duration", minWidth: 120 },
    { key: "creativeType", label: "Creative Type", minWidth: 160 },
    { key: "impressions", label: "Impressions", minWidth: 160 },
    { key: "clicks", label: "Clicks", minWidth: 120 },
    { key: "ctr", label: "CTR", minWidth: 100 },
    { key: "video_completes", label: "Video Completes", minWidth: 130 },
    { key: "video_plays", label: "Video Plays", minWidth: 130 },
    { key: "video_midpoints", label: "Video Midpoints", minWidth: 130 },
    { key: "createdDate", label: "Creative Date", minWidth: 170 },
  ];

  const rows = creativeAssets
    .sort((a, b) => new Date(b.createdAt).valueOf() - new Date(a.createdAt).valueOf())
    .map((asset) => {
      const {
        name,
        description,
        createdAt,
        creativeType,
        height,
        width,
        bgCreativeId,
        creativeSrc,
        duration,
        adLibCreativeId,
        adLibCreativeReports,
      } = asset;

      const creativeReport =
        selectedTimeFrame === ReportTimeFrames.CUSTOM_DATE
          ? creativeDailyReports.find((creativeDailyReport) => creativeDailyReport.adLibCreativeId === adLibCreativeId)
          : adLibCreativeReports?.length
          ? adLibCreativeReports[0]
          : null;

      const id = bgCreativeId;

      const imageRegex: RegExp = /^image\//;

      const row = {
        id,
        asset: imageRegex.test(creativeType) ? (
          <img className={classes.creativeAssetImg} src={creativeSrc} alt="Creative Asset" />
        ) : (
          // eslint-disable-next-line jsx-a11y/media-has-caption
          <video controls style={{ width: "300px" }}>
            <source src={creativeSrc} type="video/mp4" />
          </video>
        ),
        name,
        description,
        height,
        width,
        creativeType,
        ctr: transformRowValue(creativeReport?.ctr ?? 0, false, true, "PERCENTAGE"),
        impressions: transformRowValue(creativeReport?.impressions ?? 0, true, false, "FLAT"),
        clicks: transformRowValue(creativeReport?.clicks ?? 0, true, false, "FLAT"),
        createdDate: new Date(createdAt).toLocaleDateString(),
        duration: creativeType === "video/mp4" ? `${duration ?? "60"} sec` : "N/A",
      };
      return row;
    });

  return isFetchingCreatives ? (
    <div className={classes.loaderContainer}>
      <Loader isAbsolutePosition={false} size={36} />
    </div>
  ) : (
    <BaseDataTableWithSort columns={columns} rows={rows} />
  );
};

export default CreativeAssetsManagement;
